import { FC, ReactNode, useState } from 'react';

import { Collapse } from 'antd';

import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

import styles from './CollapseSection.module.scss';

interface CollapseSectionProps {
  title: string;
  summary: ReactNode;
  details?: ReactNode | null;
  index: number;
}

const CollapseSection: FC<CollapseSectionProps> = ({
  title,
  summary,
  details,
  index
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <div className={styles.textContainer}>{summary}</div>
      {details && (
        <Collapse
          ghost
          onChange={handleExpandToggle}
          expandIcon={({ isActive }) =>
            isActive ? <MinusIcon /> : <PlusIcon />
          }
          className={styles.sectionContainer}
        >
          <Collapse.Panel
            header={expanded ? 'Show less' : 'Learn more'}
            key={index}
          >
            <div className={styles.textContainer}>{details}</div>
          </Collapse.Panel>
        </Collapse>
      )}
    </div>
  );
};

export default CollapseSection;
